import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }
}));

const ApprovedClients = ({ className, ApprovedArray, ApprovedArrayPercentage, totalArray, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              APPROVED CLIENTS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {totalArray === 0 ? '......' : ApprovedArray}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleOutlineIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowUpwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {totalArray === 0 ? '......' : ApprovedArrayPercentage.toFixed(2)}% &nbsp;
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Of total submitted forms
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

ApprovedClients.propTypes = {
  className: PropTypes.string
};

export default ApprovedClients;
